module.exports = __webpack_public_path__ + "static/head-bg.864f0b5b.png";